import {errorPromptData, promptData} from "../../util/MessageTools";
import {mapState} from "vuex";
import api from '../../api'
import router from "../../router";

export default {
  name: 'enterFor',
  computed: mapState([
    'user',
    'enterForPageHint',
    'enterForPageCheck',
    'enterForPageSuccess',
  ]),

  data() {

    return {
      // thesisOneForm: {//第一阶段提交投稿信息
      //   chName: "",
      //   enName: "",
      //   chKeyWords1: "",
      //   chKeyWords2: "",
      //   chKeyWords3: "",
      //   chKeyWords4: "",
      //   chKeyWords5: "",
      //   enKeyWords1: "",
      //   enKeyWords2: "",
      //   enKeyWords3: "",
      //   enKeyWords4: "",
      //   enKeyWords5: "",
      // },
      // thesisOneResultForm: {
      //   chName: "",
      //   enName: "",
      //   chKeyWords: "",
      //   enKeyWords: "",
      //   abstractOriginalName: "",
      //   refereeOpinionInfoFirst: "",//第一阶段评语

      // },
      // thesisOneRules: {
      //   chName: [
      //     {required: true, message: '请输入中文名称', trigger: 'submit'},
      //     {min: 1, max: 500, message: '中文名称不能超过500个文字', trigger: 'submit'},
      //   ],
      //   enName: [
      //     {required: true, message: '请输入英文名称', trigger: 'submit'},
      //     {min: 1, max: 500, message: '英文名称不能超过500个字母', trigger: 'submit'},
      //   ],
      //   chKeyWords1: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
      //   ],
      //   chKeyWords2: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
      //   ],
      //   chKeyWords3: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
      //   ],
      //   chKeyWords4: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
      //   ],
      //   chKeyWords5: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个文字', trigger: 'submit'},
      //   ],
      //   enKeyWords1: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
      //   ],
      //   enKeyWords2: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
      //   ],
      //   enKeyWords3: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
      //   ],
      //   enKeyWords4: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
      //   ],
      //   enKeyWords5: [
      //     {required: true, message: '请输入关键字', trigger: 'submit'},
      //     {min: 1, max: 50, message: '单个关键字不能超过50个英文字母', trigger: 'submit'},
      //   ],
      // },

      // oneFileName: '',
      twoFileName: '',
      threeFileName: '',

      // oneFile: '',
      twoFile: '',
      threeFile: '',

      oneContributeDiv: true,
      twoContributeDiv: true,
      threeContributeDiv: true,

      oneResultDiv: false,
      twoResultDiv: false,
      threeResultDiv: false,

      refereeOpinionInfoSecond: "",//第二阶段评语
      refereeOpinionInfoThird: "",//第三阶段评语

      refereeStatusFirst: "",
      refereeStatusSecond: "",
      refereeStatusThird: "",

      oneDisabled: false,//第一阶段提交按钮
      twoDisabled: false,//第二阶段的提交按钮
      threeDisabled: false,//第三阶段的提交按钮
    }
  },
  methods: {

    /**
     * 自己理解就是过度,因为上传文件是点确定提交才上传的(方法忽略)
     */
    excessive() {
    },

    beforeAvatarUpload1(file) {

      let n = file.name.lastIndexOf(".");
      let suffix = file.name.substr(n + 1);
      if (suffix !== "zip" && suffix !== "rar") {
        this.$message.error('请上传zip/rar格式的压缩文件!');
        return
      }
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error('第一阶段上传文件不能超过 10MB!');
        return
      }
      this.oneFile = file
      this.oneFileName = file.name
      return
    },


    beforeAvatarUpload2(file) {
      let n = file.name.lastIndexOf(".");
      let suffix = file.name.substr(n + 1);
      if (suffix !== "docx" && suffix !== "doc") {
        this.$message.error('请上传word文件!');
        return
      }
      //this.twoFileName = file.name
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error('第二阶段上传文件不能超过 10MB!');
        return
      }
      this.twoFile = file
      this.twoFileName = file.name
      return
    },


    beforeAvatarUpload3(file) {
      let n = file.name.lastIndexOf(".");
      let suffix = file.name.substr(n + 1);
      if (suffix !== "zip" && suffix !== "rar") {
        this.$message.error('请上传zip/rar格式的压缩文件!');
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error('第三阶段上传文件不能超过 10MB!');
        return
      }
      this.threeFile = file
      this.threeFileName = file.name
      return
    },

    // /**
    //  * 保存第一阶段投稿
    //  */
    // saveOneData(formName) {
    //   let vue = this
    //   vue.oneDisabled = true
    //   this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         let chName = vue.thesisOneForm.chName
    //         let enName = vue.thesisOneForm.enName
    //         let chKeyWords = vue.thesisOneForm.chKeyWords1 + "," + vue.thesisOneForm.chKeyWords2 + "," + vue.thesisOneForm.chKeyWords3 + "," + vue.thesisOneForm.chKeyWords4 + "," + vue.thesisOneForm.chKeyWords5
    //         let enKeyWords = vue.thesisOneForm.enKeyWords1 + "," + vue.thesisOneForm.enKeyWords2 + "," + vue.thesisOneForm.enKeyWords3 + "," + vue.thesisOneForm.enKeyWords4 + "," + vue.thesisOneForm.enKeyWords5

    //         api.contribute.saveOneData(vue.oneFile, chName, enName, chKeyWords, enKeyWords).then(function (response) {
    //           vue.oneDisabled = false
    //           if (response === null) {
    //             return null
    //           }
    //           if (response.data.code === "0") {
    //             vue.oneContributeDiv = false;
    //             vue.oneResultDiv = true
    //             vue.refereeStatusFirst = 'REFEREEING'
    //             let obj = {}
    //             obj.chName = chName
    //             obj.enName = enName
    //             obj.chKeyWords = chKeyWords
    //             obj.enKeyWords = enKeyWords
    //             obj.abstractOriginalName = vue.oneFileName
    //             vue.giveOneResultValue(obj)
    //           }
    //         }).catch(()=>{
    //           vue.oneDisabled = false
    //         })
    //       } else {
    //         vue.oneDisabled = false
    //       }
    //     }
    //   );
    // },

    /**
     * 保存第二阶段和第三阶段的数据
     */
    saveTwoAndThreeData() {
      let vue = this
      vue.threeDisabled = true
      let curRound = router.app.$options.store.state.curRound
      let file = ""
      if (curRound === 2) {
        file = this.twoFile
      } else if (curRound === 3) {
        file = this.threeFile
      }

      api.contribute.updateRound(file).then(function (response) {
        vue.threeDisabled = false
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          if (curRound === 2) {
            vue.twoContributeDiv = false;
            vue.twoResultDiv = true
            vue.refereeStatusSecond = "REFEREEING"
            vue.twoFileName = vue.twoFileName
          } else if (curRound === 3) {
            vue.threeContributeDiv = false;
            vue.threeResultDiv = true
            vue.refereeStatusThird = "REFEREEING"
            vue.threeFileName = vue.threeFileName
          }

        }
      }).catch(error =>{
        vue.threeDisabled = false
      })
    },

    /**
     * 隐藏div
     */
    hideDiv() {
      this.oneResultDiv = false;
      this.twoResultDiv = false;
      this.threeResultDiv = false;

      this.oneContributeDiv = false;
      this.twoContributeDiv = false;
      this.threeContributeDiv = false;
    },

    /**
     * 给第一阶段赋值
     * @param result
     */
    giveOneResultValue(result) {
      this.thesisOneResultForm.chName = result.chName
      this.thesisOneResultForm.enName = result.enName
      let splits = result.chKeyWords.split(",")
      let splits1 = result.enKeyWords.split(",")
      let chKeyWords = ""
      for (let i = 0; i < splits.length; i++) {
        if (splits[i].trim() === "") {
          continue
        } else {
          chKeyWords += splits[i] + ","
        }
      }
      let enKeyWords = ""
      for (let j = 0; j < splits1.length; j++) {
        if (splits1[j].trim() === "") {
          continue
        } else {
          enKeyWords += splits1[j] + ","
        }
      }
      chKeyWords = chKeyWords.substring(0, chKeyWords.lastIndexOf(","));
      enKeyWords = enKeyWords.substring(0, enKeyWords.lastIndexOf(","));
      this.thesisOneResultForm.chKeyWords = chKeyWords
      this.thesisOneResultForm.enKeyWords = enKeyWords
      this.thesisOneResultForm.abstractOriginalName = result.abstractOriginalName
      this.thesisOneResultForm.refereeOpinionInfoFirst = result.refereeOpinionInfoFirst
    },

    /**
     * 给第二阶段赋值
     * @param result
     */
    giveTwoResultValue(result) {
      this.twoFileName = result.briefOriginalName
      this.refereeOpinionInfoSecond = result.refereeOpinionInfoSecond
    },

    /**
     * 给第三阶段赋值
     * @param result
     */
    giveThreeResultValue(result) {
      this.threeFileName = result.bodyOriginalName
      this.refereeOpinionInfoThird = result.refereeOpinionInfoThird
    },

  },


  created() {
    let vue = this
    api.contribute.getAllRoundThesisResult().then(function (response) {
      if (response === null) {
        return null
      }
      if (response.data.code === "0") {
        vue.hideDiv()
        let result = response.data.result
        let curRound = result.curRound
        let round1Submit = router.app.$options.store.state.round1Submit
        let round2Submit = router.app.$options.store.state.round2Submit
        let round3Submit = router.app.$options.store.state.round3Submit
        vue.refereeStatusFirst = result.refereeStatusFirst
        vue.refereeStatusSecond = result.refereeStatusSecond
        vue.refereeStatusThird = result.refereeStatusThird
        switch (curRound) {
          case 1:
            vue.twoDisabled = true
            vue.threeDisabled = true
            vue.twoContributeDiv = true
            // vue.threeContributeDiv = true //2026-1-19 暂时注释，第一轮时只展示摘要的审核状态，不展示第三阶段的内容
            switch (result.refereeStatusFirst) {
              case "NODATA"://第一阶段没有提交
                vue.oneContributeDiv = true
                if (round1Submit === 0) {
                  vue.oneDisabled = true
                  //promptData("第一阶段投稿暂未开启!", vue)
                  return
                } else {
                  vue.oneDisabled = false
                }
                break
              case "APPROVED"://通过
              case "REFEREEING"://审核中
                vue.oneContributeDiv = false
                // vue.giveOneResultValue(result)
                vue.oneResultDiv = true
                break
              case "REFUSED"://拒绝
                // vue.giveOneResultValue(result)
                vue.oneContributeDiv = false
                vue.oneResultDiv = true
                vue.twoContributeDiv = false
                vue.threeContributeDiv = false
                break
            }
            break
          case 2:
            vue.threeDisabled = true
            vue.twoDisabled = true
            if (result.refereeStatusFirst === "APPROVED") {//如果第一轮审核通过
              vue.oneResultDiv = true
              vue.twoContributeDiv = true
              vue.threeContributeDiv = true
              vue.giveOneResultValue(result)
              if (result.refereeStatusSecond === "NODATA") {//第二轮没提交
                if (round2Submit === 1) {
                  vue.twoDisabled = false
                }
              } else {
                if (result.refereeStatusSecond === "REFUSED") {
                  vue.threeContributeDiv = false
                }
                vue.twoContributeDiv = false
                vue.twoResultDiv = true
                vue.giveTwoResultValue(result)
              }
            } else {
              if (result.refereeStatusFirst === "NODATA") {//第一阶段没有提交
                errorPromptData("第一阶段您没有投稿,您失去参赛资格!", vue)
                router.push({path: '/'})
                return
              }/*else if(result.refereeStatusFirst === "REFUSED"){
                vue.oneResultDiv = true
                errorPromptData("第一阶段您没有投稿,您失去参赛资格!", vue)
                //router.push({path: '/'})
                return
              }*/ else {
                vue.oneResultDiv = true
                vue.giveOneResultValue(result)
              }

            }
            break
          case 3:
            vue.threeDisabled = true
            if (result.refereeStatusFirst === "APPROVED") {//如果第一轮审核通过
              // vue.oneResultDiv = true
              vue.threeContributeDiv = true
              // vue.giveOneResultValue(result)
              if (result.refereeStatusThird === "NODATA") {//第三轮没提交
                if (round3Submit === 1) {
                  vue.threeDisabled = false
                }
              } else {
                vue.threeContributeDiv = false
                vue.threeResultDiv = true
                vue.giveThreeResultValue(result)
              }
            } else {
              if (result.refereeStatusFirst === "NODATA") {//第一阶段没有提交
                errorPromptData("第一阶段您没有投稿,您失去参赛资格!", vue)
                router.push({path: '/'})
                return
              }/*else if(result.refereeStatusFirst === "REFUSED"){
                vue.oneResultDiv = true
                errorPromptData("第一阶段您没有投稿,您失去参赛资格!", vue)
                //router.push({path: '/'})
                return
              }*/ else {
                vue.oneResultDiv = true
                // vue.giveOneResultValue(result)
              }
            }
            break
          // case 3:
          //   vue.oneResultDiv = true
          //   vue.twoResultDiv = true
          //   vue.threeDisabled = true
          //   if (result.refereeStatusSecond === "APPROVED") {//如果第二轮审核通过
          //     vue.oneResultDiv = true
          //     vue.twoResultDiv = true
          //     vue.giveOneResultValue(result)
          //     vue.giveTwoResultValue(result)
          //     if (result.refereeStatusThird === "NODATA") {//第三轮没提交
          //       if (round3Submit === 1) {
          //         vue.threeDisabled = false
          //         vue.threeContributeDiv = true
          //       }
          //     } else {
          //       vue.threeResultDiv = true
          //       vue.giveThreeResultValue(result)
          //     }
          //   } else {
          //     vue.twoResultDiv = true
          //     vue.giveOneResultValue(result)
          //     vue.giveTwoResultValue(result)
          //   }
          //   break
        }
      }
      /* if (response.data.code === "0") {
         vue.hideDiv()
         let result = response.data.result
         let curRound = result.curRound
         let currentTime = new Date().getTime()//当前时间
         let oneStartTime = new Date(router.app.$options.store.state.register_enter_oneContribute_startTime).getTime()
         let oneEndTime = new Date(router.app.$options.store.state.register_enter_oneContribute_endTime).getTime()
         let twoStartTime = new Date(router.app.$options.store.state.twoContribute_startTime).getTime()
         let twoEndTime = new Date(router.app.$options.store.state.twoContribute_endTime).getTime()
         let threeStartTime = new Date(router.app.$options.store.state.threeContribute_startTime).getTime()
         let threeEndTime = new Date(router.app.$options.store.state.threeContribute_endTime).getTime()
         vue.refereeStatusFirst = result.refereeStatusFirst
         vue.refereeStatusSecond = result.refereeStatusSecond
         vue.refereeStatusThird = result.refereeStatusThird

         switch (curRound) {
           case 1:
             vue.twoDisabled = true
             vue.threeDisabled = true
             vue.twoContributeDiv = true
             vue.threeContributeDiv = true
             switch (result.refereeStatusFirst) {
               case "NODATA"://第一阶段没有提交
                 if (currentTime > oneStartTime && currentTime < oneEndTime) {
                   vue.oneContributeDiv = true
                 } else {
                   errorPromptData("第一阶段投稿已结束,您失去参赛资格!")
                   router.push({path: '/'})
                   return
                 }
                 break
               case "APPROVED"://通过
               case "REFEREEING"://审核中
                 vue.giveOneResultValue(result)
                 vue.oneResultDiv = true
                 break
               case "REFUSED"://拒绝
                 vue.giveOneResultValue(result)
                 vue.oneResultDiv = true
                 vue.twoContributeDiv = false
                 vue.threeContributeDiv = false
                 break
             }
             break
           case 2:
             vue.threeDisabled = true
             vue.twoDisabled = true
             if (result.refereeStatusFirst === "APPROVED") {//如果第一轮审核通过
               vue.oneResultDiv = true
               vue.twoContributeDiv = true
               vue.threeContributeDiv = true
               vue.giveOneResultValue(result)
               if (result.refereeStatusSecond === "NODATA") {//第二轮没提交
                 if (currentTime > twoStartTime && currentTime < twoEndTime) {
                   vue.twoDisabled = false
                 }
               } else {
                 if(result.refereeStatusSecond ==="REFUSED"){
                   vue.threeContributeDiv = false
                 }
                 vue.twoContributeDiv = false
                 vue.twoResultDiv = true
                 vue.giveTwoResultValue(result)
               }
             } else {
               if (result.refereeStatusFirst === "NODATA") {//第一阶段没有提交
                 errorPromptData("第一阶段您没有投稿,您失去参赛资格!",vue)
                 router.push({path: '/'})
                 return
               } else {
                 vue.oneResultDiv = true
                 vue.giveOneResultValue(result)
               }

             }
             break
           case 3:
             vue.oneResultDiv = true
             vue.twoResultDiv = true
             vue.threeDisabled = true
             if (result.refereeStatusSecond === "APPROVED") {//如果第二轮审核通过
               vue.oneResultDiv = true
               vue.twoResultDiv = true
               vue.giveOneResultValue(result)
               vue.giveTwoResultValue(result)
               if (result.refereeStatusThird === "NODATA") {//第三轮没提交
                 if (currentTime > threeStartTime && currentTime < threeEndTime) {
                   vue.threeDisabled = false
                   vue.threeContributeDiv = true
                 }
               } else {
                 vue.threeResultDiv = true
                 vue.giveThreeResultValue(result)
               }
             } else {
               vue.twoResultDiv = true
               vue.giveTwoResultValue(result)
             }
             break
         }
       }*/
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Contribute/Contribute.js